window.addEventListener("scroll", function() {
  const header = window.scrollY;
  const headerElement = document.querySelector("header");
  const btnMobile = document.querySelector('.btn-mobile');

  if (header > 50) {
    headerElement.classList.add("active");
    btnMobile.classList.add('scroll');
  } else {
    headerElement.classList.remove("active");
    btnMobile.classList.remove('scroll');
  }

});